import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  openModal: boolean;
  modalMessage: string;
  onRequestClose: () => void;
  isSmallScreen: boolean;
  isMaxAttempts?: boolean;
  onProceed?: () => void;
}

function WebCheckInPopUp({
  openModal,
  modalMessage,
  onRequestClose,
  isSmallScreen,
  isMaxAttempts = false,
  onProceed,
}: Props) {
  const { t: translate } = useTranslation();

  return (
    <Dialog
      open={openModal}
      onClose={onRequestClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          borderRadius: "16px",
          padding: isSmallScreen ? 0 : "2rem",
          minWidth: isSmallScreen ? 0 : "400px",
          textAlign: "center",
        },
      }}
    >
      {/* Title */}
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          color: "#19344FCC",
          fontSize: "22px",
          lineHeight: isSmallScreen ? "115%" : "100%",
          textAlign: "center",
          fontWeight: isSmallScreen ? 550 : 600,
          padding: isSmallScreen ? "1rem" : "8px",
          whiteSpace: "pre-line",
        }}
      >
        {modalMessage}
      </DialogTitle>

      {/* Content */}
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={isMaxAttempts ? onProceed : onRequestClose}
          sx={{
            backgroundColor: "#19344F",
            color: "#FFFFFF",
            borderRadius: "30px",
            px: 4,
            py: 1,
            textTransform: "none",
            "&:hover": { backgroundColor: "#19344F" },
            marginBottom: isSmallScreen ? "5px" : 0,
          }}
        >
          {isMaxAttempts ? translate("Proceed") : translate("Try again")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(WebCheckInPopUp);
